import $ from "jquery"
import { trace } from "./../shared/helpers.js"

// Alert Article (Home)
// with cookie
const OpenInModal = {

  // ### init ###
  init() {
    $('body').on('click', '.open-modal[data-modal-content]', (e)=> {
      e.preventDefault();
      let selector = $(e.currentTarget).data("modal-content");
      let $content = $(selector);
      // trace($(e.currentTarget).data(), selector, $content);
      if ($content.length) {
        let $modal = $('#s-modal');
        // trace($modal);
        if ($modal.length) {
          let $body = $modal.find('.modal-body');
          $body.html( $content.html() );
          $modal.modal('show');
        }
      }
    });
  }

}

export default OpenInModal;